module.exports = __webpack_public_path__ + "static/media/Design Sysem-2x.8a85f3ca.jpeg";